import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';
import { toURLSearchParams } from '@/utils/url';

import { type ContractsSearchParams, contractsApiSchema } from '../../models';
import { logger } from '../../utils/logger';

const contracts = fetcher.extend(() => ({ prefixUrl: `${API.CONTRACTS}` }));

export const fetchContracts = async (
  searchParams: ContractsSearchParams,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  const {
    cargoType,
    carrierKey,
    createdBy,
    customerLaneId,
    effectiveFrom,
    effectiveTo,
    modifiedBy,
    name,
    pricingBasis,
    pricingCategory,
    pricingType,
    skip,
    sorting,
    status,
    supplierDiversity,
    take,
    transportationMode,
    uniqueName,
  } = searchParams;

  try {
    return await contracts
      .get('search', {
        searchParams: toURLSearchParams({
          CargoType: cargoType,
          CarrierKey: carrierKey,
          CreatedBy: createdBy,
          CustomerLaneId: customerLaneId,
          EffectiveFrom: effectiveFrom,
          EffectiveTo: effectiveTo,
          ModifiedBy: modifiedBy,
          Name: name,
          PricingBasis: pricingBasis,
          PricingCategory: pricingCategory,
          PricingType: pricingType,
          Skip: skip,
          Sorting: sorting || undefined,
          Status: status,
          SupplierDiversity: supplierDiversity,
          Take: take,
          TransportationMode: transportationMode,
          UniqueName: uniqueName,
        }),
        signal,
      })
      .json(contractsApiSchema);
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
